import { googleLogin } from "api/auth.api";
import { notificationController } from "components/Common/Notification/Notification";
import { APP_CONSTANTS } from "components/constants/AppConstants";
import { useAppDispatch } from "hooks/reduxHooks";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { doGoogleLogin } from "store/slices/authSlice";

const loadScript = (src: any) =>
  new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });
const SSOLogin = () => {
  const googleButton = useRef(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const src = "https://accounts.google.com/gsi/client";
    //CLIENT ID
    const id = "816361360496-8ufj9n1dtc0052rv9980e55paf0t228r.apps.googleusercontent.com";

    loadScript(src)
      .then(() => {
        /*global google*/
        const goog: any = window.google;
        goog?.accounts.id.initialize({
          client_id: id,
          callback: handleCredentialResponse,
        });
        goog?.accounts.id.renderButton(googleButton.current, {
          type: "standard",
          theme: "outline",
          size: "large",
          width: 350,
          margin: "auto",
        });
      })
      .catch(console.error);

    return () => {
      const scriptTag = document.querySelector(`script[src="${src}"]`);
      if (scriptTag) document.body.removeChild(scriptTag);
    };
  }, []);

  function handleCredentialResponse(response: any) {
    if (response.credential) {
      const data = { auth_token: response.credential };
      dispatch(doGoogleLogin(data))
        .unwrap()
        .then((data: any) => {
          const win: any = window;
          win.location = APP_CONSTANTS.index;
        })
        .catch((err: any) => {
          notificationController.error({
            message:
              "Something went wrong while logging in with Google. Please check your subscription.",
          });
          // setLoading(false);
        });
    }
  }

  return (
    <div id="google-login-btn">
      <div ref={googleButton} id="google-ref" className="text-left"></div>
    </div>
  );
};

export default SSOLogin;
